import axios from "../config/axios"

// WhatsApp connectors of registry projects: the WhatsApp Cloud API number a project sends from
// (WhatsappConnectorDTO). The access token is never returned, only accessTokenSet.
export const WhatsappConnectorRepository = {
  getByProject: (projectId) => axios.get(`/api/connector/whatsapp/project/${projectId}`),
  get: (id) => axios.get(`/api/connector/whatsapp/${id}`),
  // body: CreationWhatsappConnectorDTO (projectId and accessToken required)
  create: (body) => axios.post(`/api/connector/whatsapp`, body),
  // empty accessToken keeps the stored one
  edit: (id, body) => axios.put(`/api/connector/whatsapp/${id}`, body),
  delete: (id) => axios.delete(`/api/connector/whatsapp/${id}`),

  // {connected, connectorId, connectorName, phoneNumberId, displayPhoneNumber}
  getStatus: (projectId) => axios.get(`/api/connector/whatsapp/project/${projectId}/status`),
  // sends through the project's enabled connector (409 without one).
  // body: {to, text} or {to, templateName, languageCode, bodyParameters}
  send: (projectId, body) => axios.post(`/api/connector/whatsapp/project/${projectId}/send`, body),
}
